// File: /asset/js/advanced-product-filter.js

jQuery(document).ready(function ($) {
  if (typeof filterWidgetData === "undefined") {
    return;
  }

  if (
    !woodmartThemeModule.$body.hasClass("woodmart-ajax-shop-on") ||
    typeof $.fn.pjax === "undefined" ||
    woodmartThemeModule.$body.hasClass("single-product") ||
    woodmartThemeModule.$body.hasClass("elementor-editor-active") ||
    $('.products[data-source="main_loop"]').length === 0
  ) {
    return;
  }

  const AdvancedProductFilter = (function () {
    const selectors = {
      filterForm: "#advanced-product-filter-form",
      filterSummaryBtn: ".filter-summary",
      attributeFilterBtn: ".attribute-filter",
      popover: ".popover",
      selectedFiltersContainer: ".selected-filters",
      clearAllBtn: ".clear-all",
      removeFilterLink: ".selected-filters a.selected-filter",
      applyFiltersBtn: "#apply_filters",
      closeFilterBtn: "#close_filter",
      priceFilterCheckbox: 'input[name="price_range[]"]',
      removeAllBtn: ".remove-all",
      viewResultsBtn: ".view-results",
      closePopoverBtn: ".close-popover",
      priceSliderMin: "#min_price",
      priceSliderMax: "#max_price",
      priceMinDisplay: "#price_min_display",
      priceMaxDisplay: "#price_max_display",
      filterContainer: ".advanced-product-filter-container",

      inputMinPrice: "#input_min_price",
      inputMaxPrice: "#input_max_price",
    };

    const taxonomyLabels = filterWidgetData.taxonomy_labels || {};
    const priceRanges = filterWidgetData.price_ranges || {};
    const translations = filterWidgetData.translations || {};

    const init = function () {
      bindEvents();
      handlePopovers();
      const minVal = $(selectors.priceSliderMin).val();
      const maxVal = $(selectors.priceSliderMax).val();
      updatePriceRangeHighlight(minVal, maxVal);

      setTimeout(function () {
        $(`${selectors.priceSliderMin}, ${selectors.priceSliderMax}`).show();
      }, 1000);
    };

    const bindEvents = function () {
      syncInput(selectors.inputMinPrice, selectors.priceSliderMin);
      syncInput(selectors.inputMaxPrice, selectors.priceSliderMax);

      // When checkboxes change in the aggregate popover
      $(document).on(
        "change",
        `${selectors.priceFilterCheckbox}, ${selectors.filterForm} input[type='checkbox']`,
        function (e) {
          e.preventDefault();
          updateSelectedFilters();
        }
      );

      $(document).on("click", selectors.removeFilterLink, function (e) {
        e.preventDefault();
        const currentUrl = new URL(window.location.href);
        const filterKey = $(this).data("filter-key");
        let filterValue = $(this).data("filter-value");

        var filterParam = "";
        var queryTypeParam = "";
        if (filterKey && filterValue) {
          if (filterKey === "min_price" || filterKey === "max_price") {
            filterParam = filterKey;
            filterValue = String(filterValue);
          } else {
            filterParam = `filter_${filterKey}`;
            queryTypeParam = `query_type_${filterKey}`;
          }

          const existingValues =
            currentUrl.searchParams.get(filterParam)?.split(",") || [];

          const updatedValues = existingValues.filter((v) => v !== filterValue);

          if (updatedValues.length > 0) {
            currentUrl.searchParams.set(filterParam, updatedValues.join(","));
          } else {
            currentUrl.searchParams.delete(filterParam);
            currentUrl.searchParams.delete(queryTypeParam);
          }

          const newUrl = currentUrl.toString();
          $.pjax({
            url: newUrl,
            container: ".wd-page-content",
            timeout: 0,
            push: true,
            scrollTo: false,
            error: function () {
              console.error("Failed to remove filter.");
            },
          });
        } else {
          console.error("Filter key or value missing.");
        }
      });

      // Clear all filters when clicking on "Clear All"
      $(document).on("click", selectors.clearAllBtn, function (e) {
        e.preventDefault();
        $(this).closest(".popover").addClass("hidden");
        clearAllFilters();
      });

      // Handle "View Results" button click
      $(document).on("click", selectors.viewResultsBtn, function (e) {
        e.preventDefault();
        $(this).closest(".popover").addClass("hidden");
        applyFilters();
      });

      // Handle "Remove All" button click
      $(document).on("click", selectors.removeAllBtn, function (e) {
        e.preventDefault();
        $(this).closest(".popover").addClass("hidden");
        clearAllFilters();
      });

      // Handle "Close" button in popover
      $(document).on("click", selectors.closePopoverBtn, function (e) {
        e.preventDefault();
        $(this).closest(".popover").addClass("hidden");
      });

      // Update price display when using slider with debounce
      const debounce = (func, delay) => {
        let debounceTimer;
        return function () {
          const context = this;
          const args = arguments;
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
      };

      $(document).on("input change", selectors.priceSliderMin, function (e) {
        e.preventDefault();
        const minVal = $(this).val();
        const formattedMinVal = formatNumber(minVal);
        $(selectors.priceMinDisplay).text(
          `${formattedMinVal} ${wooli_data.helpers.currency_symbol}`
        );
        const maxVal = $(selectors.priceSliderMax).val();
        if (parseInt(minVal) > parseInt(maxVal)) {
          $(selectors.priceSliderMax).val(minVal).trigger("change");
        }
        updateSelectedFilters();
        updatePriceRangeHighlight(minVal, maxVal);
      });

      $(document).on("input change", selectors.priceSliderMax, function (e) {
        e.preventDefault();
        const maxVal = $(this).val();
        const formattedMaxVal = formatNumber(maxVal);
        $(selectors.priceMaxDisplay).text(
          `${formattedMaxVal} ${wooli_data.helpers.currency_symbol}`
        );
        const minVal = $(selectors.priceSliderMin).val();
        if (parseInt(maxVal) < parseInt(minVal)) {
          $(selectors.priceSliderMin).val(maxVal).trigger("change");
        }
        updateSelectedFilters();
        updatePriceRangeHighlight(minVal, maxVal);
      });

      $(document).on(
        "change",
        `${selectors.filterForm} input[type='checkbox']`,
        function (e) {
          const name = $(this).attr("name");
          const value = $(this).val();
          const isChecked = $(this).is(":checked");

          $(document)
            .find(
              `${selectors.filterForm} input[type="checkbox"][name="${name}"][value="${value}"]`
            )
            .prop("checked", isChecked);

          updateSelectedFilters();
        }
      );
    };

    function updatePriceRangeHighlight(minVal, maxVal) {
      const minPercent =
        ((minVal - $(selectors.priceSliderMin).attr("min")) /
          ($(selectors.priceSliderMax).attr("max") -
            $(selectors.priceSliderMin).attr("min"))) *
        100;
      const maxPercent =
        ((maxVal - $(selectors.priceSliderMin).attr("min")) /
          ($(selectors.priceSliderMax).attr("max") -
            $(selectors.priceSliderMin).attr("min"))) *
        100;
      $("#price_range").css({
        left: `${minPercent}%`,
        width: `${maxPercent - minPercent}%`,
      });
    }

    const handlePopovers = function () {
      let screenWidth = $(window).width();

      function adjustPopover(popover) {
        let popoverWidth = popover.outerWidth();
        let buttonOffset = popover.prev().offset().left;
        let popoverRight = buttonOffset + popoverWidth;
        if (popoverRight > screenWidth) {
          popover.addClass("adjust");
        } else {
          popover.removeClass("adjust");
        }
      }

      // Toggle popover when clicking on "Filter Summary"
      $(document).on("click", selectors.filterSummaryBtn, function (e) {
        e.stopPropagation(); // Prevent event bubbling
        $(".popover").not($(this).next(selectors.popover)).addClass("hidden"); // Hide other popovers
        $(this).next(selectors.popover).toggleClass("hidden"); // Toggle current popover
      });

      // Toggle popover when clicking on individual attribute buttons
      $(document).on("click", selectors.attributeFilterBtn, function (e) {
        e.stopPropagation();
        let $this = $(this);
        let popover = $this.next(selectors.popover);
    
        // Ẩn tất cả popover khác và toggle popover hiện tại
        $(".popover").not(popover).addClass("hidden");
        popover.toggleClass("hidden");

        adjustPopover(popover);
      });

      // Prevent hiding popover when clicking inside it
      $(document).on("click", selectors.popover, function (e) {
        e.stopPropagation();
      });

      // Hide popover when clicking outside
      $(document).on("click", function () {
        $(".popover").addClass("hidden");
      });

      $(window).on("resize", function () {
        screenWidth = $(window).width();
        $(".popover:not(.hidden)").each(function () {
          adjustPopover($(this));
        });
      });
    };

    /**
     * Update the display of selected filters
     */
    const updateSelectedFilters = function () {
      return false;
      const selectedFilters = {};
      // Get all checked checkboxes
      $('input[type="checkbox"]:checked').each(function () {
        const name = $(this).attr("name");
        const value = $(this).val();
        const label = $(this).data("attr-filter-label");
        // const label = $(this).val();

        if (name.startsWith("filter_")) {
          const filterName = name.replace(/^filter_/, "").replace(/\[\]$/, "");
          if (!selectedFilters[filterName]) {
            selectedFilters[filterName] = [];
          }
          selectedFilters[filterName].push({ value, label });
        } else if (name === "price_range[]") {
          if (!selectedFilters["price_range"]) {
            selectedFilters["price_range"] = [];
          }
          selectedFilters["price_range"].push(value);
        }
      });

      // Get values from price sliders if enabled
      const minPrice = $(selectors.priceSliderMin).val();
      const maxPrice = $(selectors.priceSliderMax).val();

      if (minPrice && minPrice != $(selectors.priceSliderMin).attr("min")) {
        // Check if different from default min
        selectedFilters["min_price"] = minPrice;
      }
      if (maxPrice && maxPrice != $(selectors.priceSliderMax).attr("max")) {
        // Check if different from default max
        selectedFilters["max_price"] = maxPrice;
      }

      // Clear previous selected filters
      $(selectors.selectedFiltersContainer).empty();

      // Add selected filters
      $.each(selectedFilters, function (key, values) {
        if (key === "min_price" || key === "max_price") {
          const label =
            key === "min_price"
              ? translations.min_price
              : translations.max_price;
          const displayValue = key === "min_price" ? minPrice : maxPrice;

          const removeUrl = getRemoveFilterUrl(key, displayValue);
          $(selectors.selectedFiltersContainer).append(`
                        <a href="${removeUrl}" class="selected-filter bg-[var(--wd-primary-color)] text-white px-3 py-1 rounded flex items-center space-x-1 mb-2" aria-label="${
            translations.remove_filter
          }">
                            <span>${label}: ${formatNumber(displayValue)} ${
            wooli_data.helpers.currency_symbol
          }</span>
                            <span class="remove-filter">&times;</span>
                        </a>
                    `);
        } else if (key === "price_range") {
          $.each(values, function (index, value) {
            const priceLabel = getPriceRangeLabel(value);
            const removeUrl = getRemovePriceRangeUrl(value);
            $(selectors.selectedFiltersContainer).append(`
                            <a href="${removeUrl}" class="selected-filter bg-green-500 text-white px-3 py-1 rounded flex items-center space-x-1 mb-2" aria-label="${translations.remove_price_range}">
                                <span>${translations.price_range}: ${priceLabel}</span>
                                <span class="remove-filter">&times;</span>
                            </a>
                        `);
          });
        } else {
          $.each(values, function (index, value) {
            const taxonomyLabel = getTaxonomyLabel(key);
            const removeUrl = getRemoveFilterUrl(key, value.value);
            const existingFilter = $(selectors.selectedFiltersContainer).find(
              `a:contains(${taxonomyLabel}):contains(${decodeURIComponent(
                value.label
              )})`
            );

            if (existingFilter.length === 0) {
              $(selectors.selectedFiltersContainer).append(`
                            <a href="${removeUrl}" class="selected-filter bg-[var(--wd-primary-color)] text-white px-3 py-1 rounded flex items-center space-x-1 mb-2"
                            aria-label="${translations.remove_filter}"
                            data-filter-key="${key}"
                            data-filter-value="${value.value}">
                                <span>${taxonomyLabel}: ${decodeURIComponent(
                value.label
              )}</span>
                                <span class="remove-filter">&times;</span>
                            </a>
                        `);
            }
          });
        }
      });

      // If there are selected filters, display the "Clear All" button
      if (Object.keys(selectedFilters).length > 0) {
        // Ensure "Clear All" button appears only once
        if (
          $(selectors.selectedFiltersContainer).find(".clear-all").length === 0
        ) {
          const clearAllUrl = $(selectors.clearAllBtn).attr("href");
          $(selectors.selectedFiltersContainer).append(`
                        <a href="${clearAllUrl}" class="clear-all bg-red-500 text-white px-3 py-1 rounded mb-2" aria-label="${translations.clear_all}">
                            ${translations.clear_all}
                        </a>
                    `);
        }
      }
    };

    /**
     * Get taxonomy label based on taxonomy name
     */
    const getTaxonomyLabel = function (taxonomy) {
      taxonomy_prefix = "pa_" + taxonomy;

      return (
        taxonomyLabels[taxonomy] ||
        taxonomyLabels[taxonomy_prefix] ||
        taxonomy.charAt(0).toUpperCase() + taxonomy.slice(1)
      );
    };

    /**
     * Get price range label based on range key
     */
    const getPriceRangeLabel = function (range) {
      return priceRanges[range] || range;
    };

    /**
     * Get URL to remove a specific filter
     */
    const getRemoveFilterUrl = function (filterKey, filterValue) {
      // Find the corresponding <a> tag with the matching filterKey and filterValue
      const link = $(
        `.selected-filters a.selected-filter[href*="filter_${filterKey}"]`
      )
        .filter(function () {
          return $(this).attr("href").includes(encodeURIComponent(filterValue));
        })
        .first();
      return link.attr("href") || window.location.href;
    };

    /**
     * Get URL to remove a specific price range
     */
    const getRemovePriceRangeUrl = function (rangeKey) {
      // Find the corresponding <a> tag with the matching rangeKey
      const link = $(`.selected-filters a.selected-filter[href*="price_range"]`)
        .filter(function () {
          return $(this).attr("href").includes(encodeURIComponent(rangeKey));
        })
        .first();
      return link.attr("href") || window.location.href;
    };

    /**
     * Apply filters using PJAX
     */
    const applyFilters = function () {
      // Collect filter values from the form
      const formData = $(selectors.filterForm).serializeArray();
      const params = {};
      const queryTypes = {};

      formData.forEach(function (field) {
        const name = field.name;
        const value = field.value;

        if (name.startsWith("filter_")) {
          // Remove 'filter_' and '[]' from parameter name
          const filterName = name.replace(/^filter_/, "").replace(/\[\]$/, "");
          if (!params[filterName]) {
            params[filterName] = [];
          }
          params[filterName].push(value);

          queryTypes[filterName] = "or";
        } else if (name === "min_price" || name === "max_price") {
          const minPriceDefault = $(selectors.priceSliderMin).attr("min");
          const maxPriceDefault = $(selectors.priceSliderMax).attr("max");

          if (
            (name === "min_price" && value !== minPriceDefault) ||
            (name === "max_price" && value !== maxPriceDefault)
          ) {
            params[name] = value;
          }
        } else if (name === "price_range[]") {
          const filterName = "price_range";
          if (!params[filterName]) {
            params[filterName] = [];
          }
          params[filterName].push(value);

          queryTypes[filterName] = "or";
        }
      });

      for (const key in params) {
        if (params.hasOwnProperty(key) && Array.isArray(params[key])) {
          params[key] = [...new Set(params[key])];
        }
      }

      // Build new URL with filter parameters
      let currentUrl = new URL(window.location.href);
     
      // Remove `/page/x/` in path
      currentUrl.pathname = currentUrl.pathname.replace(/\/page\/\d+\//, "/");

      // Remove existing filter parameters
      const keysToDelete = Array.from(currentUrl.searchParams.keys()).filter(
        (key) =>
          key.startsWith("filter_") ||
          key.startsWith("query_type_") ||
          key === "min_price" ||
          key === "max_price"
      );
      keysToDelete.forEach((key) => currentUrl.searchParams.delete(key));

      //   currentUrl.searchParams.forEach((value, key) => {
      //     if (
      //       key.startsWith("filter_") ||
      //       key.startsWith("query_type_") ||
      //       key === "min_price" ||
      //       key === "max_price"
      //     ) {
      //       currentUrl.searchParams.delete(key);
      //     }
      //   });

      // Add new filter parameters
      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          if (Array.isArray(params[key])) {
            currentUrl.searchParams.set(`filter_${key}`, params[key].join(","));
            currentUrl.searchParams.set(`query_type_${key}`, queryTypes[key]); // Thêm query_type_
          } else {
            currentUrl.searchParams.set(key, params[key]);
          }
        }
      }

      // Add PJAX parameter
      // currentUrl.searchParams.set("_pjax", ".wd-page-content");

      // Send PJAX request
      $.pjax({
        url: currentUrl.toString(),
        container: ".wd-page-content",
        timeout: 0,
        push: true, // Add to browser history
        scrollTo: false, // Prevent scrolling to top
        renderCallback: function (context, html, afterRender) {
          woodmartThemeModule.removeDuplicatedStylesFromHTML(
            html,
            function (html) {
              context.html(html);
              afterRender();
              woodmartThemeModule.$document.trigger("wdShopPageInit");
              woodmartThemeModule.$document.trigger("wood-images-loaded");
            }
          );
        },
      });
    };

    function syncInput(input, hidden) {
      if (!$(input).length || !$(hidden).length) return;

      $(document).on("input", input, function () {
        let rawValue = $(this).val().replace(/\D/g, "");
        if (rawValue !== "") {
          $(this).val(formatNumber(rawValue));
          $(hidden).val(rawValue);
        } else {
          $(this).val("");
          $(hidden).val("");
        }
      });
    }

    function formatNumber(value) {
      if (typeof value === "number") {
        return value.toLocaleString("vi-VN");
      }
      let num = value.replace ? parseInt(value.replace(/\D/g, ""), 10) : NaN;
      return isNaN(num) ? "" : num.toLocaleString("vi-VN");
    }

    /**
     * Reset all filters to default state
     */
    const clearAllFilters = function () {
      // Reset all checkboxes
      $('input[type="checkbox"]').prop("checked", false).trigger("change");
      // Reset price sliders if any
      $(selectors.priceSliderMin)
        .val($(selectors.priceSliderMin).attr("min"))
        .trigger("change");
      $(selectors.priceSliderMax)
        .val($(selectors.priceSliderMax).attr("max"))
        .trigger("change");
      // Update display
      updateSelectedFilters();

      applyFilters();
    };

    return {
      init: init,
      //   bindEvents: bindEvents,
      updatePriceRangeHighlight: updatePriceRangeHighlight,
    };
  })();

  AdvancedProductFilter.init();

  //   $(document).on('pjax:end', function () {
  //       AdvancedProductFilter.bindEvents();
  //   });

  $(document)
    .off("pjax:complete")
    .on("pjax:complete", function () {
      const minPrice = $('input[name="min_price"]').val();
      const maxPrice = $('input[name="max_price"]').val();
      AdvancedProductFilter.updatePriceRangeHighlight(minPrice, maxPrice);

      $(".elementor-widget-image-carousel").each(function () {
        let wrapper = $(this);
        let swiperContainer = wrapper.find(".swiper");
        let settings = wrapper.data("settings");

        if (!settings || swiperContainer.length === 0) return;

        if (swiperContainer[0].swiper) {
          swiperContainer[0].swiper.destroy(true, true);
        }

        let swiperInstance = new Swiper(swiperContainer.get(0), settings);
      });
    });
});
